import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import { getOtherOptionsFromWindow, createRegxpPatternFromWildcardedName } from "../utils";
import { getUserDecision } from "../others";
/**
 * Synchronously check if a consent is given. See `window.consentApi.consent` for more documentation.
 */

function consentSync(type, name,
/**
 * This can also be `*` to allow all hosts.
 */
host) {
  // Find matching cookie
  var found;

  var _getOtherOptionsFromW = getOtherOptionsFromWindow(),
      groups = _getOtherOptionsFromW.groups;

  var allCookies = groups.map(function (_ref) {
    var items = _ref.items;
    return items;
  }).flat();

  var _iterator = _createForOfIteratorHelper(allCookies),
      _step;

  try {
    loop1: for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var row = _step.value;
      var technicalDefinitions = row.technicalDefinitions;

      if (technicalDefinitions !== null && technicalDefinitions !== void 0 && technicalDefinitions.length) {
        // Check if technical information matches
        var _iterator2 = _createForOfIteratorHelper(technicalDefinitions),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var td = _step2.value;
            var regexp = createRegxpPatternFromWildcardedName(td.name);

            if (td.type === type && (td.name === name || name.match(regexp)) && (td.host === host || host === "*")) {
              found = row;
              break loop1;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (found) {
    // Check if consent is already given
    var already = getUserDecision();

    if (already) {
      var consentCookieIds = Object.values(already.consent).flat();

      if (consentCookieIds.indexOf(found.id) > -1) {
        return {
          cookie: found,
          consentGiven: true,
          cookieOptIn: true
        };
      } else {
        return {
          cookie: found,
          consentGiven: true,
          cookieOptIn: false
        };
      }
    } else {
      return {
        cookie: found,
        consentGiven: false,
        cookieOptIn: false
      };
    }
  } else {
    return {
      cookie: null,
      consentGiven: !!getUserDecision(),
      cookieOptIn: true
    };
  }
}

export { consentSync };